
<template>
    <div class="flex flex-row w-full h-full bg-gray-300 p-4">
  
      <div class="flex flex-col w-[800px] p-4 bg-gray-50">
        <slot name="monthly"></slot>
      </div>
  
      <div class="flex flex-col flex-grow ml-4 p-2 bg-gray-50 border">
        <slot name="interactives"></slot>
      </div>
  
    </div>
  </template>
  